// Globals
import { useState } from 'react';

// Modules
import { ChatContainer } from '@/modules/Chat';
import { SocketContainer } from '@/modules/Socket';

// Components
import { LogoIcon } from '@/icons';
import {
  StyledFloatButton,
  StyledChat,
  StyledChatButton,
  StyledContainer,
  StyledWidget,
  StyledWrapper
} from './WidgetContainerStyles';

const WidgetContainer = () => {
  const [chatOpened, setChatToggle] = useState(false);

  const handleToggleChat = () => setChatToggle((prev) => !prev);

  return (
    <StyledWidget>
      {chatOpened && (
        <StyledChat>
          <SocketContainer>
            <ChatContainer onClose={handleToggleChat} />
          </SocketContainer>
        </StyledChat>
      )}
      {!chatOpened && (
        <StyledContainer>
          <StyledFloatButton onClick={handleToggleChat}>
            <LogoIcon />
          </StyledFloatButton>
          <StyledWrapper>
            <StyledChatButton onClick={handleToggleChat} data-tooltip="Need Help?">
              Need Help?
            </StyledChatButton>
          </StyledWrapper>
        </StyledContainer>
      )}
    </StyledWidget>
  )
};

export default WidgetContainer;
